import { QueryClientProvider } from 'react-query';
import { reactQueryClient } from '@api/client';
import Initializer from '@components/Initializer';
import { ModalProvider } from '@context/Modal';
import { BackHandlerProvider } from '@context/BackHandler';
import { PaymentMethodsProvider } from '@context/Payment/PaymentMethods';
import { DoctorProvider } from '@context/Doctor';
import { TreatmentInformationProvider } from '@context/TreatmentInformation';
import Footer from '@components/Footer';

import Router from './router';

function App() {
  return (
    <QueryClientProvider client={reactQueryClient}>
      <Initializer>
        <ModalProvider>
          <BackHandlerProvider>
            <PaymentMethodsProvider>
              <DoctorProvider>
                <TreatmentInformationProvider>
                  <Router />
                  <Footer />
                </TreatmentInformationProvider>
              </DoctorProvider>
            </PaymentMethodsProvider>
          </BackHandlerProvider>
        </ModalProvider>
      </Initializer>
    </QueryClientProvider>
  );
}

export default App;
